import React from "react";
import numeral from "numeral";
import { useTranslation } from "react-i18next";
import { Timestamp } from "components/common";
const ExecutionInfo = ({ duration, executedAt, total = void 0, showTotal = true, executionFinished }) => {
  const { t } = useTranslation("search");
  if (!executionFinished) {
    return /* @__PURE__ */ React.createElement("i", null, t("execution_info.no_query"));
  }
  return /* @__PURE__ */ React.createElement("i", null, t("execution_info.query_executed", { duration: numeral(duration).format("0,0") }), " ", /* @__PURE__ */ React.createElement(Timestamp, { dateTime: executedAt }), " ", showTotal && t("execution_info.total_results", { total: numeral(total).format("0,0") }));
};
export default ExecutionInfo;
